import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  kullaniciGetir,
  kullaniciGuncelle,
  kullaniciOlustur,
  kullaniciSil,
  kullanicilariListele,
  rolleriListele,
  type Kullanici,
  type KullaniciGuncelleIstegi,
  type KullaniciOlusturIstegi,
  type Rol,
  type SayfalanmisKullanicilar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useKullanicilar(sayfa: number, boyut = 50) {
  return useQuery<SayfalanmisKullanicilar>({
    queryKey: ['kullanicilar', 'liste', sayfa, boyut],
    queryFn: () => kullanicilariListele(istemci, sayfa, boyut),
    placeholderData: (o) => o,
  });
}

export function useKullanici(id: string | undefined) {
  return useQuery<Kullanici>({
    queryKey: ['kullanicilar', 'detay', id ?? ''],
    queryFn: () => kullaniciGetir(istemci, id as string),
    enabled: !!id,
  });
}

export function useRoller() {
  return useQuery<Rol[]>({
    queryKey: ['kullanicilar', 'roller'],
    queryFn: () => rolleriListele(istemci),
  });
}

export function useKullaniciOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (g: KullaniciOlusturIstegi) => kullaniciOlustur(istemci, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kullanicilar'] }),
  });
}

export function useKullaniciGuncelle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...g }: KullaniciGuncelleIstegi & { id: string }) =>
      kullaniciGuncelle(istemci, id, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kullanicilar'] }),
  });
}

export function useKullaniciSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => kullaniciSil(istemci, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['kullanicilar'] }),
  });
}
